<template>
  <div v-if="object.attribute != null && dataReady">
    <div class="row text-white inner-row">
      <div class="col-md-3" style="text-align: left">
        <base-input label="Аттрибут"
                    v-model="object.attribute"
                    :placeholder="object.attribute">
        </base-input>
      </div>
      <div class="col-md-2">
        <items-option :label="'Тип объекта'" :object="object.entity" @update="setEntity" :items-data="entities">
        </items-option>
      </div>
      <div class="col-md-3" :key="linksKey">
        <items-option :label="'Ссылка на данные'" :object="object.link" @update="setLink" :items-data="links">
        </items-option>
      </div>
      <div class="col-md-3">
        <items-option :label="'Тип отображения данных'" :object="object.fieldType" @update="setFieldType" :items-data="fieldTypes">
        </items-option>
      </div>
      <div class="col-md-1" style="text-align: center; alignment: center">
        <p><br/></p>
        <p v-on:click="object.attribute = null" style="text-align: center; vertical-align: center">
          Удалить
        </p>
      </div>
    </div>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {},
     fieldTypes: [],
     entities: []
   },
   data() {
     return {
       object: this.item.object,
       links: [],
       dataReady: false,
       linksKey: 0
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     },
     setLink(link) {
       this.item.object.link = link.value;
     },
     setFieldType(type) {
       this.item.object.fieldType = type.value;
     },
     async setEntity(type) {
       this.item.object.entity = type.value;
       this.links = await this.$repo.getSelector('admin/document_field_links/' + this.item.object.entity);
       this.linksKey++;
     }
   },
   async mounted() {
     this.links = await this.$repo.getSelector('admin/document_field_links/' + this.item.object.entity);
     this.dataReady = true;
   }
 }
</script>
<style>
</style>
